var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tableList),function(item,index){return _c('Table',{key:index,attrs:{"border":"","columns":item.columns,"data":item.tableData},scopedSlots:_vm._u([{key:"address",fn:function(ref){
var row = ref.row;
var index = ref.index;
return _c('Address',{attrs:{"readonly":true,"value":row.address}})}},{key:"pickupAddress",fn:function(ref){
var row = ref.row;
var index = ref.index;
return _c('AddressList',{attrs:{"readonly":true,"noUpdate":true,"list":row.pickupAddress}})}},{key:"receiveAddress",fn:function(ref){
var row = ref.row;
var index = ref.index;
return _c('AddressList',{attrs:{"readonly":true,"noUpdate":true,"list":row.receiveAddress}})}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7fc97a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tableWrap.vue
// module id = null
// module chunks = 